import {Inject, Injectable} from '@angular/core';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {catchError, firstValueFrom, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {TASK_CONFIG, TaskConfig} from '@mydocma/task';
import { Logger } from '@mydocma/common/src/lib/logger';

@Injectable()
export class TaskApiService extends BasedataService {
  constructor(private http: HttpClient, configService: ConfigService,
              @Inject(TASK_CONFIG) private taskConfig: TaskConfig,
              private readonly logger: Logger) {
    super(configService);
  }

  getAll(fromDays: number): Promise<any[]> {

    const date = new Date();
    date.setDate(date.getDate() - fromDays);
    const fromDate = date.toISOString().split('T')[0];
    const param = new URLSearchParams({ from: fromDate });

    const endpoint = `${this.taskConfig.apiUrl.replace(/\/+$/, '')}/tasks?` + param.toString();



    return firstValueFrom(this.http.get<any[]>(endpoint, { headers: this.getHeaders() })
      .pipe(
        map(x => {
          return x;
        }),
        catchError((e) => {
          this.logger.error(e, '', 'TaskApiService');
          return of(null);
        })
      ));
  }

  delete(id: string) {
    const endpoint = `${this.taskConfig.apiUrl.replace(/\/+$/, '')}/tasks/${id}`;

    return firstValueFrom(this.http.delete(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => {
        this.logger.error(e, '', 'TaskApiService');
        return of(null);
      })));
  }
}
